<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Reabertura de Ciclo"
    :formErrors="formErrors"
    deleteConfirmButtonLabel="Reabrir"
    deleteIcon="mdi-lock-open"
    deleteButtonLabel="Reabrir Ciclo"
    deleteColor="green"
    :alwaysEnabled="true"
  >

    <BaseUtil
      ref="util"
      :pageLoading="loading"
    />
    <p> Você tem certeza que reabrir o ciclo <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";
// import DateField from "@shared_components/date_field.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
 data () {
  return {
    entryAttributes: {},
    error: null,
    loading: false,
    formErrors: [],
  }
},
components: {
  BaseDelete: BaseDelete,
  // DateField: DateField,
  BaseUtil: BaseUtil,
},
props: {
  entry: Object,
},
 methods: {
  getObject: function(element, component) {
    return this.entryAttributes[element];
  },
   destroyServerEntry: function(period) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: REOPEN_PERIOD_MUTATION,
          variables: {
            id: period.id,
          }
        })
        .then(response => {
          var errors = response.data.reopenPeriod.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const REOPEN_PERIOD_MUTATION = gql `
  mutation($id: ID!) {
    reopenPeriod(id: $id) {
      period {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>